// extracted by mini-css-extract-plugin
export default {"search-button":"MOiREY3jIR3xRIPBBKNX","searchButton":"MOiREY3jIR3xRIPBBKNX"};